import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ScUserService } from 'src/app/core/services/sc/sc-user.service';
import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { SfcWoOrderAttendantService } from 'src/app/core/services/wo-order/sfc-order-attendant.service';
import { WoOrderSortingService } from 'src/app/core/services/wo-order/wo-order-sorting.service';
import { BasicChartOutput } from 'src/app/models/basic-chart.model';
import { ScUserMessageOutput } from 'src/app/models/response/sc-user.model';
import { WoOrderAttendantKpiOutput, WoOrderAttendantOutput } from 'src/app/models/sfc-order-attendant.model';
import { WoOrderOutput } from 'src/app/features/wo-order/wo-order.model';
import { Observable, timer, takeUntil, Subject } from 'rxjs';

@Component({
    selector: 'app-sfc-dashboard-service',
    templateUrl: './sfc-dashboard-service.component.html',
    styleUrls: ['./sfc-dashboard-service.component.scss'],
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .fc-header-toolbar {
                display: flex;
                flex-wrap: wrap;
            }
        }
    `]
})
export class SfcDashboardServiceComponent implements OnInit {

    public chartBackgroundColor: any = [
        'rgb(103,139,193)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(148,184,180, 0.2)',
        'rgba(150,83,18, 0.2)',
        'rgba(44,62,80, 0.2)',
        'rgba(153,153,153, 0.2)',
        'rgba(175,132,219, 0.2)',
        'rgba(255,247,102, 0.2)',
        'rgba(252,238,229, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(251,139,30, 0.2)',
        'rgba(179,92,53, 0.2)',
        'rgba(128,139,150, 0.2)',
        'rgba(193,193,193, 0.2)',
        'rgba(73,30,117, 0.2)',
        'rgba(153,145,0, 0.2)',
        'rgba(0,150,123, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(252,185,120, 0.2)',
        'rgba(209,157,133, 0.2)',
        'rgba(26,37,48, 0.2)',
        'rgba(122,51,196, 0.2)',
        'rgba(255,242,0, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(251,228,213, 0.2)',
        'rgba(0,250,206, 0.2)',
        'rgba(150,136,127, 0.2)',
        'rgba(102,252,225, 0.2)',
    ];
    public chartBorderColor: any = [
        'rgb(103,139,193)',
        'rgb(75, 192, 192)',
        'rgb(148,184,180)',
        'rgb(150,83,18)',
        'rgb(44,62,80)',
        'rgb(153,153,153)',
        'rgb(175,132,219)',
        'rgb(255,247,102)',
        'rgb(252,238,229)',
        'rgb(54, 162, 235)',
        'rgb(251,139,30)',
        'rgb(179,92,53)',
        'rgb(128,139,150)',
        'rgb(193,193,193)',
        'rgb(73,30,117)',
        'rgb(153,145,0)',
        'rgb(0,150,123)',
        'rgb(153, 102, 255)',
        'rgb(252,185,120)',
        'rgb(209,157,133)',
        'rgb(26,37,48)',
        'rgb(122,51,196)',
        'rgb(255,242,0)',
        'rgb(153, 102, 255)',
        'rgb(251,228,213)',
        'rgb(0,250,206)',
        'rgb(150,136,127)',
        'rgb(102,252,225)',
    ];


    private readonly POLLING_INTERVAL = 30000; // 30 seconds
    private taskLoading$ = new Subject<boolean>();
    private destroy$ = new Subject<void>();


    public userId?: string;
    public orderList: WoOrderAttendantOutput[] = [];
    public orderListClient: WoOrderAttendantOutput[] = [];
    public orderListAttendant: WoOrderAttendantOutput[] = [];

    public orderChart: BasicChartOutput[] = [];
    public orderKpi: WoOrderAttendantKpiOutput[] = [];
    public chatList: ScUserMessageOutput[] = [];

    public chartOptions: any;
    public chartData: any;





    public kpiSorting: number = 0;
    public kpiMonthService: number = 0;
    public kpiMonthClosed: number = 0;
    public kpiMonthClient: number = 0;
    public kpiMonthConversion: number = 0;


    public activeOrder: number = 0;
    public screenHeightOrder: string = window.innerWidth > 120 ? (window.innerHeight - 530).toString() + 'px' : '400px';
    public screenHeightChat: string = window.innerWidth > 120 ? (window.innerHeight - 500).toString() + 'px' : '400px';
    public language: string = "pt-BR";
    public pageMessage: string = "";



    readonly AVATAR_COLOR_FROM = '#908871';
    readonly AVATAR_COLOR_OWN = "#6AA84F";
    public userAcronym: string = 'SC'; // Default acronym, can be set dynamically based on user data

    fullcalendarOptions: any;

    displaySendMessage: boolean = false;
    dialogHeaderSendMessage: string = '';
    woOrder: WoOrderOutput = {};
    woOrderIdSelected: string = '';

    constructor(private orderAttendantService: SfcWoOrderAttendantService,
                private userService: ScUserService,
                private userTokenService: UserTokenService,
                private translateService: TranslateService,
                private translateConfigService: TranslateConfigService,
                private router: Router,
                private orderSortingService: WoOrderSortingService) {

    }

    ngOnInit() {
        this.userId = this.userTokenService.getUserId();
        this.getList();
        this.getKpi();
        this.getChart();
        this.getMessage();


    }

    getList() {
        this.orderAttendantService.getList().subscribe(
            {
                next: (res) => {
                    if (res){
                        this.orderList = res.items;
                        this.orderListAttendant = this.orderList.filter(item => !item.isClientTask);
                        this.orderListClient = this.orderList.filter(item => item.isClientTask);
                    }
                },
                error: (err) => {
                    console.log(`SfcDashboardService - getList : ${err}.`);
                }
            });
    }

    getKpi() {
        this.orderAttendantService.getKpi().subscribe(
            {
                next: (res) => {
                    if (res){
                        const targetDate = new Date('2025-01-01');
                        const da = new Date('2025-05-25T20:45:35.9120923')
                        this.orderKpi = res.items;

                        const filteredByDate = this.orderKpi;//.filter(item => new Date(item.CreatedAt) >= targetDate);
                        const clients = filteredByDate.map(item => item.scClientId);

                        this.kpiSorting = this.orderKpi.filter(item => item.stage == "OPEN").length;
                        this.kpiMonthService = filteredByDate.length;
                        this.kpiMonthClosed = Math.round((filteredByDate.filter(item => item.isClosed == true).length +1 / filteredByDate.length) * 100);
                        this.kpiMonthClient = new Set(clients).size;
                        this.kpiMonthConversion = filteredByDate.filter(item => item.stage != "CANCELED" && item.stage != "QUOTE" && item.stage != "WAIT" && item.stage != "OPEN").length;
                    }
                },
                error: (err) => {
                    console.log(`SfcDashboardService - getKpi : ${err}.`);
                }
            });
    }

    getChart() {
        this.orderAttendantService.getChart().subscribe(
            {
                next: (res) => {
                    if (res){
                        this.orderChart = res.items;
                        this.setChart();
                    }
                },
                error: (err) => {
                    console.log(`SfcDashboardService - getList : ${err}.`);
                }
            });




    }

    getMessage() {
        this.userService.getListUserMessage("TargetUserId_SourceUserId = "+this.userId).subscribe(
            {
                next: (res) => {
                    if (res) {
                        this.chatList = res.data;
                    }
                },
                error: (err) => {
                    console.log(`SfcWoOrderClientGrid - getMessage : ${err}.`);
                }
            });
    }

    setChart(){
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        this.chartData = {
            labels: this.orderChart.map(item => item.name),
            datasets: [
                {
                    label: 'Tipo de Serviços',
                    data: this.orderChart.map(item => item.quantity),
                    backgroundColor: this.chartBackgroundColor,
                    borderColor: this.chartBorderColor,
                    borderWidth: 1
                }
            ]
        };

        this.chartOptions = {
            plugins: {
                legend: {
                    labels: { color: textColor }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: { color: textColorSecondary },
                    grid: { color: surfaceBorder, drawBorder: false}
                },
                x: {
                    ticks: { color: textColorSecondary },
                    grid: { color: surfaceBorder, drawBorder: false}
                }
            }
        };
    }

    getInitials(name: string): string {
        if (!name || typeof name !== 'string' || name.trim() === '') {
            return '??'; // Default for invalid or empty names
        }

        const nameParts = name.trim().split(/\s+/);

        if (nameParts.length === 0) {
            return '??';
        }

        const firstInitial = nameParts[0].charAt(0).toUpperCase();

        if (nameParts.length > 1) {
            const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
            return firstInitial + lastInitial;
        } else {
            // Only one name part, use its first letter twice
            return firstInitial + firstInitial;
        }
    }

    newService() {
        this.router.navigate(['/order/client-new']);
    }

    myServices(){
        this.router.navigate(['/order/client-my-orders']);
    }

    myData() {
        this.router.navigate(['/user-profile']);
    }

    getOrder(item: any){

    }

    translate() {
        this.language = this.translateConfigService.getLanguage();

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));
        (async () => {
            await sleep(50);
            //  const lab0 = this.translateService.instant('label.home') + ' ';
            //  const lab1 = ' ' + this.translateService.instant('label.serviceSorting');

            // this.BREAD_CRUMB_LIST = [
            //     {label: lab0,routerLink: '/',selected: false},
            //     {label: lab1,routerLink: '/order/order-sorting',selected: true}
            // ]


            this.pageMessage = this.translateService.instant('grid.showing') + " {first} " + this.translateService.instant('grid.to') + " {last} " + this.translateService.instant('grid.of') + " {totalRecords} " + this.translateService.instant('grid.entries')
        })();



    }

    openDialogSendMessage(woOrderId: string) {


        if (this.woOrder?.id !== undefined && woOrderId === this.woOrderIdSelected) {
            this.displaySendMessage = true;
            this.dialogHeaderSendMessage = this.translateService.instant('message.new_message');
            return;
        }

        this.orderSortingService.getItem(woOrderId).subscribe(
            {
                next: (res) => {
                    if (res) {
                        this.woOrder = res.data;
                        if (this.woOrder != null && this.woOrder != undefined && (this.woOrder.obs == null || this.woOrder.obs == undefined || this.woOrder.obs == '')) {
                            this.woOrder.obs = ' - ';
                        }

                        this.displaySendMessage = true;
                        this.dialogHeaderSendMessage = this.translateService.instant('message.new_message');
                    }
                },
                error: (err) => {
                    console.log(`SfcDashboardServiceComponent - openDialogSendMessage : ${err}.`);
                    console.log(err);
                }
            });

        this.woOrderIdSelected = woOrderId;
    }
      /**
     * Sets up a polling mechanism that calls `onGetStatusNext` every 10 seconds
     * to refresh the available actions for the order.
     */
      private setupPollingForStatus(): void {
        // Start after 10 seconds, then repeat every 10 seconds.
        timer(this.POLLING_INTERVAL, this.POLLING_INTERVAL)
            .pipe(takeUntil(this.taskLoading$ || this.destroy$))
            .subscribe(() => {
                this.getList();
            });
    }
}

